import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/supporter/$supporterId/settings/")({
  beforeLoad: ({ params }) => {
    throw redirect({ to: "/supporter/$supporterId/settings/billing", params: { supporterId: params.supporterId } });
  },
});
